import { Directive,  } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[noBlankString]',
  providers: [{provide: NG_VALIDATORS, useExisting: NoBlankStringDirective, multi: true}]
})
export class NoBlankStringDirective implements Validator {

  constructor() { }


  validate(control: AbstractControl): ValidationErrors | null {

    if ((control.value||'')==''){
      return null;
    }
    else if ((control.value||'').trim()==''){
      return {'Errors/noBlankString':'chaine vide non autorisée'};
    } else {
      return null;
    }
  }
}

